import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { mapCustomerRecordSnCodes } from './snCodeWire';

/**
 * 客戶詳情。
 * `GET /crm/customer/{id}` — Ver4 detail envelope。
 *
 * @param {string} id
 */
export async function fetchCustomerDetail(id) {
  const { data: raw } = await request.get(`/crm/customer/${id}`);
  const parsed = parseVer4DetailResponse(raw);
  return { ...parsed, data: mapCustomerRecordSnCodes(parsed.data) };
}
